import { useQuery } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import { urls } from '../../config/urls';

export const useTaxTypes = () => {
  return useQuery('taxTypes', () =>
    axiosInstance.get(urls.taxTypes.all).then((res) => res.data)
  );
};
